import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Books from "@/pages/Books";
import TrekTravel from "@/pages/TrekTravel";
import TrekDetail from "@/pages/TrekDetail";
import Music from "@/pages/Music";
import AIMedia from "@/pages/AIMedia";
import Contact from "@/pages/Contact";
import BlogIndex from "@/pages/BlogIndex";
import BlogDetail from "@/pages/BlogDetail";
import AuthCallback from "@/pages/AuthCallback";
import AdminGate from "@/components/AdminGate";
import AdminComments from "@/pages/AdminComments";
import AdminBlogs from "@/pages/AdminBlogs";
import AdminBlogEditor from "@/pages/AdminBlogEditor";
import { AuthProvider } from "@/context/AuthContext";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/books" element={<Books />} />
              <Route path="/trek-and-travel" element={<TrekTravel />} />
              <Route path="/trek-and-travel/:slug" element={<TrekDetail />} />
              <Route path="/music" element={<Music />} />
              <Route path="/ai-media" element={<AIMedia />} />
              <Route path="/blogs" element={<BlogIndex />} />
              <Route path="/blogs/:slug" element={<BlogDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/admin/comments" element={<AdminComments />} />
              <Route
                path="/admin/blogs"
                element={
                  <AdminGate>
                    <AdminBlogs />
                  </AdminGate>
                }
              />
              <Route
                path="/admin/blogs/new"
                element={
                  <AdminGate>
                    <AdminBlogEditor />
                  </AdminGate>
                }
              />
              <Route
                path="/admin/blogs/:id/edit"
                element={
                  <AdminGate>
                    <AdminBlogEditor />
                  </AdminGate>
                }
              />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#2C2A28",
                color: "#FAF9F6",
                border: "1px solid #4A6B53",
                borderRadius: 4,
                fontFamily: "Manrope, sans-serif",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
